var swiperContainer = document.querySelector('.routine-products');
var swiper = new Swiper(swiperContainer, {
  slidesPerView: 1.25,
  spaceBetween: 17,
  loop: true,
  breakpoints: {
    991: {
      slidesPerView: 3,
      spaceBetween: 37,
    },
    750: {
      slidesPerView: 2,
      spaceBetween: 20,
    }
  },
});

function updateCenterSlides() {
  var slides = swiper.slides.length; // Get the total number of slides
  var slidesPerView = swiper.params.slidesPerView; // Get the current slidesPerView setting

  if (slides < slidesPerView) {
    swiperContainer.classList.add("center-slides");
  } 
}

updateCenterSlides();

swiper.on('slideChange', updateCenterSlides);
